/* global $ */
var Proj = (function(proj){
    'use strict';

    proj.showSchemePopup = function() {
        $('.js-scheme_popup').click(function(){
            $('.scheme__popup').fadeIn(300);
            $('.allblack').fadeIn(300);
            $('.allblack_mob ').fadeIn(300);
        });
    };

    proj.closeClick = function () {
        $('.js-close_popup, .allblack').click(function(){
            $('.popup').fadeOut(100);
            $('.allblack').fadeOut(100);
        });
    };

    proj.headerMenu = function() {
        var $menuItems = $('.header__bottom_item');
        var $pointItems = $('.top__point');

        $menuItems.add($pointItems).mouseenter(function(){
            $('.header__bottom_item[data-feature_id="'+$(this).data('feature_id')+'"]').addClass('m--hover');
            //$('.top__point[data-feature_id="'+$(this).data('feature_id')+'"]').addClass('m--hover');

        }).mouseleave(function(){
            $menuItems.removeClass('m--hover');
            $pointItems.removeClass('m--hover');
        });
    };

    proj.showMoreCat = function() {
        $('.js-cat-more').click(function() {
            var $parent_item = $(this).parents('.cat_group__items');
            var $variants_group = $parent_item.find('.variants');
            if (!$parent_item.hasClass('m--active')) {
                if ($('body').find('.header__mobile').css('display') != 'none' && $(this).parents('.variants').length == 0 ) {
                    $(this).hide();
                }
                $variants_group.find('.variants__main').html("");
                $parent_item.parent().find('.cat_group__item').removeClass('m--active');
                $parent_item.addClass('m--active');
                $(this).siblings(".m--hidden").clone().appendTo($variants_group.find('.variants__main'));
                $variants_group.find(".m--hidden").removeClass('m--hidden');
                $variants_group.slideDown(300);
            }
            else {
                $variants_group.slideUp(300).find('.variants__main').html("");
                $parent_item.removeClass('m--active');

                if ($('body').find('.header__mobile').css('display') != 'none') {
                    $parent_item.find('.js-cat-more').show();
                }
            }
        });
    };

    proj.fancyGallery = function() {
        $('.js-fancy').fancybox();
    };

    proj.formRequest = function(){

        var $form = $('#form_request');

        if($form.length){
            // $form.hide();

            initToggler();
        }

        /* показать form_request*/
        function initToggler() {
            $('body').on('click', '.js-form_requestToggle', function() {
                var $this = $(this);

                if(!this.__initialText){
                    this.__initialText = $this.text();
                } 
                
                if(!this.__loaded){
                    var that = this;

                    if(!this.__loading){

                        this.__loading = true;
                        proj.Feedback({
                            wrap:'#form_request',
                            callback: function(){
                                that.__loaded = true;
                                that.__loading = false;

                                toggleShow(that);
                            }
                        });
                    }
                } else {
                    toggleShow(this);
                }
            });
        }

        function toggleShow(el){
            if(el.__shown){
                $(el).text(el.__initialText);
                el.__shown = false;
                $form.stop(true, true).slideUp(300);
            } else {
                $(el).text('Скрыть форму');
                el.__shown = true;
                $form.stop(true, true).slideDown(300);
            }
        }

    };

    /**
     *  Функция для приведения вывода числа, как цены
     *  opt - хеш параметров
     *      price - число, которое нужно представить как цену
            kop - флаг, что нужно показать копейки
            sign - признак и одновременно символ валюты
            no_tags - флаг форматирования без тегов
     */
    proj.toPrice = function(opt) {
        var price = opt.price.toFixed(2);

        var rub = Math.floor(price).toString();
        var kop = Math.floor((price - parseInt(price) + 0.001) * 100).toString();

        var l = rub.length;
        var i = 0;
        var html = '';

        while (i < l) {
            var k = ((i == 0) && (l % 3 > 0))
                ? l % 3
                : 3;
            if (i + k < l) {
                if(opt.no_tags){
                    html += rub.substr(i, k) + ' ';
                }else{
                    html += '<span>' + rub.substr(i, k) + '</span>';
                }

            } else {
                html += rub.substr(i, k);
            }
            i += k;
        }

        if(opt.kop){
            if (kop.length < 2)
                kop = '0' + kop;
            html += ',' + kop;
        }

        if(opt.sign){
            if(opt.no_tags){
                html += ' '+ opt.sign;
            }else{
                html += ' <ins>'+ opt.sign +'</ins>';
            }
        }
        return html;
    }

    return proj;

})(Proj || {});



